import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import homeworksPreviewMobile from '@/assets/images/diary-unsubscripted-mobile.webp';
import homeworksPreview from '@/assets/images/diary-unsubscripted.webp';
import { Button } from '@/components/Button';
import { ROUTE_SUBSCRIPTION } from '@/router/routes';
import { ButtonVariant } from '@/types/components';

export const HomeworksPaywall: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="relative overflow-hidden rounded-xl bg-card p-6 shadow-card contrast:border contrast:border-border md:p-4">
      <div className="relative z-10 flex max-w-[184px] flex-col items-start gap-2 md:max-w-none">
        <h3 className="text-title-24 md:text-headline-20 text-foreground">
          {t('diary.homeworks.paywallTitle')}
        </h3>
        <p className="text-body-13 md:text-body-14 text-muted-foreground">
          {t('diary.homeworks.paywallDescription')}
        </p>
        <Button
          variant={ButtonVariant.Primary}
          className="mt-6 max-md:h-12"
          onClick={() => navigate(ROUTE_SUBSCRIPTION)}
        >
          {t('home.banner.ctaBuy')}
        </Button>
      </div>

      <img
        src={homeworksPreviewMobile}
        alt=""
        className="absolute right-4 bottom-0 w-[130px] md:hidden"
      />

      <img
        src={homeworksPreview}
        alt=""
        className="absolute right-6 bottom-0 hidden w-[331px] md:block"
      />
    </div>
  );
};
